import Vue from 'vue'
import tinymce from 'vue-tinymce-editor'
import orgServices from '../../../../services/notisphere/organization'
import authService from '../../../../services/auth'
Vue.component('tinymce', tinymce)
export default {
    name: 'Step2EmailVerification',
    props: {
        organizationId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            info: null,
            items: null,
            user: null,
            bodyContent: null,
            subject: null,
            isDisabled: false,
            emailList: [],
            nonVerifiedUserEmail: [],
            tinyOptions: {
                height: 280,
                branding: false,
                statusbar: false,
                nonbreaking_force_tab: true,
                indentation: '30pt',
                content_style:
          'p {font-size: 16px;color: #666666;font-family: Helvetica,Arial,sans-serif;}',
                setup: function (ed) {
                    ed.on('keydown', function (evt) {
                        if (evt.keyCode == 9) {
                            ed.execCommand('mceInsertContent', false, '&emsp;&emsp;&emsp;')
                            evt.preventDefault()
                        }
                    })
                },
            },
        }
    },
    created() {
        this.getProviderContactInfo()
    },
    methods: {
        getEmailTemplate(type) {
            orgServices.getContactInfoEmailTemplate(type).then((resp) => {
                if (!resp.error) {
                    this.items = resp.data.d
                    authService.getUserProfile().then(res1 => {
                        if (!res1.error) {
                            this.user = res1.data.d
                            this.bodyContent = /<body.*?>([\s\S]*)<\/body>/.exec(
                                this.items.content
                            )[1]
                            this.subject = this.items.subject
                            this.bodyContent = this.bodyContent.replaceAll(
                                '${ProviderName}',
                                '<span style="font-weight: 600;">' + this.info.name + '</span>'
                            )
                            this.bodyContent = this.bodyContent.replaceAll(
                                '<p style="margin-bottom: 0px; margin-top: 0px;">${ContactInfo}</p>',
                                ''
                            )
                            this.bodyContent = this.bodyContent.replaceAll(
                                'Name',
                                '<span>' + this.user?.full_name + '</span>'
                            )
                            this.bodyContent = this.bodyContent.replaceAll(
                                'Title',
                                '<span>' + (this.user?.title ? this.user?.title : '') + '</span>'
                            )
                            if (this.info?.supplier) {
                                this.bodyContent = this.bodyContent.replace(
                                    /XXX/g,
                                    this.info.supplier
                                )
                                this.subject = this.subject.replace(/XXX/g, this.info.supplier)
                            }
                        }
                    })
                }
            })
        },
        async getProviderContactInfo() {
            try {
                const [providerResp, nonVerifiedResp] = await Promise.all([
                    orgServices.getProvider(this.organizationId),
                    orgServices.getNonVerifiedUserMailList(this.organizationId),
                ])

                // Handle provider response
                if (!providerResp.error) {
                    const data = {
                        name: providerResp.data.d.name,
                        title: providerResp.data.d.title,
                        supplier: providerResp.data.d.referring_supplier,
                        centralized_intake:
              providerResp.data.d.is_centralized_setting_enabled,
                        centralized_intake_email: providerResp.data.d.centralized_email,
                    }
                    this.info = data
                }

                // Handle non-verified users response
                if (!nonVerifiedResp.error) {
                    this.nonVerifiedUserEmail = nonVerifiedResp.data.d.map(
                        (email) => email
                    )
                }

                if (!providerResp.error && !nonVerifiedResp.error) {
                    this.getEmailTemplate('PROVIDER_CONTACT_INFO_MAIL')
                    this.getVerifiedEmailList()
                }
            } catch (error) {
                console.error('Error in getProviderContactInfo:', error)
            }
        },
        async sendEmailVerification() {
            if (await this.$refs['observer'].validate()) {
                let formData = new FormData()
                for (const email of this.emailList) {
                    formData.append('email', email)
                }
                formData.append('contactInfoContent', this.bodyContent)
                formData.append('subject', this.subject)
                formData.append('providerOrgId', this.organizationId)
                orgServices.sendEmailVerification(formData).then((resp) => {
                    if (!resp.error) {
                        this._showToast('Email sent successfully!')
                        this.isDisabled = true
                    }
                })
            }
        },
        getVerifiedEmailList() {
            orgServices
                .getContactInfoVerifiedEmails(this.organizationId)
                .then((resp) => {
                    if (!resp.error) {
                        if(resp.data.d  && !resp.data.d.includes(this.info.centralized_intake_email)) {
                            this.emailList.push(this.info.centralized_intake_email)
                        }

                        this.emailList = this.emailList.concat(
                            this.nonVerifiedUserEmail.filter(
                                (email) => !resp.data.d.includes(email)
                            )
                        )

                        if(this.emailList.length === 0) {
                            this.isDisabled = true
                        }

                    }
                })
        },
    },
}
